import React, { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Caption from './Caption';

const CaptionContainer = styled.div`
	box-sizing: border-box;
    z-index: 9999;
	position: fixed;
    width: ${props => typeof props.size.width === 'string' ? props.size.width : `${props.size.width}px`};
    height: ${props => typeof props.size.height === 'string' ? props.size.height : `${props.size.height}px`};
	top: 0;
	left: 0;
	max-height: calc(100% - 50px);
	
	${(props) => !props.$hasCaption ? css`
		transform: translate(${props.$initPosition.x}px, ${props.$initPosition.y}px);
    ` : css`
		transform: translate(${props.position.x}px, ${props.position.y}px);
	`};
`;

CaptionContainer.displayName = 'Container';

CaptionContainer.defaultProps = {
	size: {},
	position: {},
};

CaptionContainer.propTypes = {
	size: PropTypes.object,
	position: PropTypes.object,
};

export default CaptionContainer;

export const useCaptionContainer = (id, { height, width, noResize }) => {
	const ref = useRef(null);

	const [caption, savedProps] = useMemo(() => {
		const caption = new Caption(id);

		return [caption, caption.getSavedCaption()];
	}, [id]);

	const [hasCaption, setHasCaption] = React.useState(caption.hasCaption);

	const [position, setPosition] = React.useState({
		x: savedProps.position.x,
		y: savedProps.position.y,
	});

	const [size, setSize] = React.useState({
		width: noResize ? width : savedProps.size.width || width,
		height: noResize ? height : savedProps.size.height || height,
	});

	caption.setRef(ref.current);

	caption.onChangeCaption = (hasCaption) => {
		setHasCaption(hasCaption);

		if (!hasCaption) {
			setSize({
				width,
				height,
			});
		}
	};

	caption.onChangePosition = (newPosition) => {
		setPosition(newPosition);
	};

	caption.onChangeSize = (newSize) => {
		setSize(newSize);
	};

	useEffect(() => () => caption.unmount(), []);

	return {
		containerProps: {
			$hasCaption: caption.hasCaption || hasCaption,
			ref,
			size,
			position,
			$initPosition: caption.__initPosition,
		},
		positionEvents: {
			onMouseDown: () => caption.startMove(),
			onMouseUp: () => caption.end(),
		},
		sizeEvents: {
			onMouseDown: () => caption.startResize(),
			onMouseUp: () => caption.end(),
		},
	};
};
